export const kSliderTileType = "CodapSlider"
export const kV2SliderType = "slider"
export const kSliderTileClass = "codap-slider"
